module.exports = __webpack_public_path__ + "6f7198412fc978b1908912b4db51646b.jpg";